<template>
  <el-upload
    class="avatar-uploader"
    :action="uploadUrl"
    :http-request="upload"
    :headers="headers"
    :before-upload="beforeUpload"
    :on-success="uploadSuccess"
    :on-error="error"
    :show-file-list="false"
    v-bind="$attrs"
    v-on="$listeners">
    <slot></slot>
    <slot name="tip" slot="tip"></slot>
  </el-upload>
</template>
<script>
import toolkit from "@/util/toolkit"
import api from "@/util/api"
export default {
  data(){
    return {
      uploadUrl: api.upload.common+`${toolkit.uploadParams()}`,
      loading: false,
      headers: {
        // AUTHORIZATION: `Bearer ${toolkit.getToken()}`
      },
      file: null,
    }
  },
  created(){
    setTimeout(() => {
      // 每分钟更新一次url
      this.uploadUrl = api.upload.common+`${toolkit.uploadParams()}`
    }, 1000);
  },
  methods: {
    upload(e){
      let url = api.upload.common+`${toolkit.uploadParams()}`
      toolkit.upload(url, this.file).then(response => {
        this.uploadSuccess(response)
      })
    },
    beforeUpload(e){
      this.$emit("before-upload", e)
      this.file = e
    },
    uploadSuccess(e){
      if(e.code == 0){
        this.$emit("upload-success", e.data)
      }else{
        this.$message.error(e.message)
      }
    },
    error(){

    }
  }
}
</script>
<style lang="scss" scoped>
.avatar-uploader{
  @include flexBox;
}
</style>


// WEBPACK FOOTER //
// src/components/CommonUpload.vue